import './SensorsMasterConfigurationsPage.css';

import React, { useEffect, useState } from 'react';
import { useLoginContext } from '../../../App';
import { useContentContext } from '../../layout/Layout';
import Banner from '../../b2b-common/Banner';
import ElementsCarousel from '../../b2b-common/ElementsCarousel';
import FrameworkCard from '../../b2b-frameworks/components/FrameworkCard';
import { fetchAPIDataWhileSettingState } from '../../b2b-common/helpers';
import { fetchFrameworksData } from '../../../services/b2b-frameworks-apiService';
import { showNotification } from '../../b2b-common/Notification';
import WaitingSpinner from '../../b2b-common/WaitingSpinner';
import LevelNCard from '../../b2b-frameworks/components/LevelNCard';
import { fetchSamplingLevelN_FwConfigurations_byFwId } from '../../../services/b2b-iotsampling-apiService';
import SensorMasterConfigurationForm from '../components/SensorMasterConfigurationForm';

const SensorsMasterConfigurationsPage = () => {

    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();

    const [iotFrameworks, setIotFrameworks] = useState(null);
    const [loadingIotFrameworks, setLoadingIotFrameworks] = useState(false);
    const [selectedFramework, setSelectedFramework] = useState(null);
    const [levelN_configurations, setLevelN_configurations] = useState(null);
    const [selectedSensor, setSelectedSensor] = useState(null);
    const [selectedLevelNConfig, setSelectedLevelNConfig] = useState(null);

    useEffect(() => {
        const fetchIotFrameworks = async () => {
            const paramsArray = [
                'iot', loginData.accessToken,
                true, // fetch images
                true, // include lelvel1s
            ];
            try {
                const iotFws = await fetchAPIDataWhileSettingState(fetchFrameworksData, paramsArray, setLoadingIotFrameworks);
                setIotFrameworks(iotFws);
            } catch (error) {
                showNotification(setNotification, 'Error fetching IoT Frameworks: ' + error.message, 'error', 5000);
            } finally {
                setLoadingIotFrameworks(false);
            }
        }
        fetchIotFrameworks();
        setSelectedFramework(null);
        setSelectedSensor(null);
    }, [loginData]);

    const getSamplingLevelN_FwConfigurations_byFwId = async (frameworkId) => {
        try {
            const levelNConfigs = await fetchSamplingLevelN_FwConfigurations_byFwId(loginData.accessToken, frameworkId);
            setLevelN_configurations(levelNConfigs);
        } catch (error) {
            showNotification(setNotification, 'Error fetching LevelN configurations: ' + error.message, 'error', 5000);
        }
    }

    const handleSelectedFramework = (framework) => {
        const frameworkKey = Number(framework.key);
        const fw = iotFrameworks.find(fw => fw.frameworkId === frameworkKey);
        setSelectedFramework(fw);
        getSamplingLevelN_FwConfigurations_byFwId(fw.frameworkId);
        setSelectedSensor(null);
    }

    const handleSelectedSensor = (sensor) => {
        const sensorLevelN_ItemId = Number(sensor.key);
        const sensorModel = selectedFramework.subLevels.find(sensor => sensor.levelN_ItemId === sensorLevelN_ItemId);
        setSelectedSensor(sensorModel);
        const levelNConfig = levelN_configurations
            .find(conf => ((conf.frameworkId === selectedFramework.frameworkId) && (conf.levelN_ItemId === sensorLevelN_ItemId)));
        setSelectedLevelNConfig(levelNConfig);
    }

    const handleCancelMasterConfiguration = () => {
        setSelectedSensor(null);
        setSelectedLevelNConfig(null);
    }

    const handleDeletedMasterConfiguration = () => {
        setSelectedSensor(null);
        setSelectedLevelNConfig(null);
        getSamplingLevelN_FwConfigurations_byFwId(selectedFramework.frameworkId);
    }

    const handleSavedMasterConfiguration = (savedConf) => {
        setSelectedSensor(null);
        setSelectedLevelNConfig(null);
        getSamplingLevelN_FwConfigurations_byFwId(selectedFramework.frameworkId);
    }

    return (
        <div className="sensors-master-configurations-page">
            <Banner sectionTittle={'Master Configuration'} message='IOT Framework Sensors' />
            <div className="sensor-master-configurations-page-frameworks">
                {loadingIotFrameworks &&
                    <WaitingSpinner text="Loading IoT Frameworks..." />
                }
                {iotFrameworks && !loadingIotFrameworks &&
                    <ElementsCarousel
                        elements={iotFrameworks.map(framework =>
                            <FrameworkCard key={framework.frameworkId} framework={framework} />
                        )}
                        onElementSelect={handleSelectedFramework}
                    />
                }
            </div>
            {selectedFramework && selectedFramework.subLevels &&
                <div className="sensor-master-configurations-page-sensors">
                    <Banner message='Select a sensor:' underline={false} headingLevel='h2' />
                    <ElementsCarousel
                        elements={selectedFramework.subLevels
                            .sort((a, b) => a.levelN_ItemName_label.localeCompare(b.levelN_ItemName_label))
                            .map(sensor =>
                                <LevelNCard key={sensor.levelN_ItemId} levelN={sensor} />
                            )}
                        onElementSelect={handleSelectedSensor}
                    />
                </div>
            }
            {selectedSensor &&
                <div className="sensor-master-configurations-page-sensor-master-configuration">
                    <Banner sectionTittle={'Master Configuration'} message={selectedSensor.levelN_ItemName} headingLevel='h3' />
                    <SensorMasterConfigurationForm
                        sensor={selectedSensor} masterConf={selectedLevelNConfig}
                        onCancel={handleCancelMasterConfiguration}
                        onDelete={handleDeletedMasterConfiguration}
                        onSave={handleSavedMasterConfiguration}
                    />
                </div>
            }
        </div>
    );
};

export default SensorsMasterConfigurationsPage;